import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

const formatLabel = (str) =>
  str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

const Field = ({ attr, isEditing, onChange, onCheckboxChange }) => (
  <div className="space-y-2">
    <div className="text-sm text-gray-500">
      <strong>{formatLabel(attr.attribute_name)}</strong>
      <FontAwesomeIcon
        icon={attr.approved ? faCircleCheck : faCircle}
        className={attr.approved ? 'ml-2 text-green-400' : 'ml-2 text-gray-400'}
      />
    </div>
    {isEditing ? (
      <>
        <input
          type="text"
          value={attr.value || ''}
          onChange={(e) => onChange(attr.id, 'value', e.target.value)}
          className="w-full bg-white border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-800"
        />
        <label className="text-xs text-gray-600 flex items-center space-x-1 mt-1">
          <input
            type="checkbox"
            checked={attr.approved || false}
            onChange={(e) => onCheckboxChange(attr.id, 'approved', e.target.checked)}
            className="rounded border-gray-300"
          />
          <span>Approved</span>
        </label>
      </>
    ) : (
      <div className="bg-gray-100 border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-800 opacity-80 whitespace-pre-line">
        {attr.value?.toString().trim() ? attr.value : '—'}
      </div>
    )}
  </div>
);

export default Field;